module.exports = __webpack_public_path__ + "img/3.28f111a8.png";